import store from '@/store/store';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';

class AdmissaoController {
  public static async getVinculosNaoAprovados(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const estrutura: Estrutura = store.getters.estruturaGerencialAtual
    const nrEstrutura = estrutura.NRESTRUTURAM;

    const cdOperador: string = store.getters.user.cdoperador;

    const route = 'getVinculosNaoAprovados';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      CDOPERADOR: cdOperador,
      NRESTRUTURAM: nrEstrutura,
    };

    const response = await HttpRequest.get(route, params, showLoading);

    if (response.data.messages) {
      const errorMessage = response.data.messages[0].message;
      throw new ExpectedError(errorMessage);
    }

    const admissoes: any[] = response.data.dataset.data;

    return admissoes;
  }

  public static async getEstadocivil(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getEstadocivil';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const estadosCivis: any[] = response.data.dataset.data;

    return estadosCivis;
  }

  public static async getCondicaoFisica(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getCondicaoFisica';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const condicoesFisicas: any[] = response.data.dataset.data;

    return condicoesFisicas;
  }

  public static async getRacaPessoa(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getRacaPessoa';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const racas: any[] = response.data.dataset.data;

    return racas;
  }

  public static async getGrauinstrucao(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getGrauinstrucao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const graus: any[] = response.data.dataset.data;

    return graus;
  }

  public static async getPais(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getPais';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const paises: any[] = response.data.dataset.data;

    return paises;
  }

  public static async getEstado(
    cdPais = '0055',
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getEstado';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      CDPAIS: cdPais,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const estados: any[] = response.data.dataset.data;

    return estados;
  }

  public static async getMunicipio(
    cdPais: string,
    sgEstado: string,
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getMunicipio';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      CDPAIS: cdPais,
      SGESTADO: sgEstado,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const municipios: any[] = response.data.dataset.data;

    return municipios;
  }

  public static async getLogradouro(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getLogradouro';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const nacionalidades: any[] = response.data.dataset.data;

    return nacionalidades;
  }

  public static async getNacionalidade(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getNacionalidade';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const nacionalidades: any[] = response.data.dataset.data;

    return nacionalidades;
  }

  public static async getClasseEstrang(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getClasseEstrang';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const classificacoes: any[] = response.data.dataset.data;

    return classificacoes;
  }

  public static async getConselhoRegional(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getConselhoRegional';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const conselhos: any[] = response.data.dataset.data;

    return conselhos;
  }

  public static async getCategoriaMilitar(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getCategoriaMilitar';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const categorias: any[] = response.data.dataset.data;

    return categorias;
  }

  public static async getTpEndereco(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getTpEndereco';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const tipos: any[] = response.data.dataset.data;

    return tipos;
  }

  public static async getBanco(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getBanco';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const bancos: any[] = response.data.dataset.data;

    return bancos;
  }

  public static async getTpContaCorrente(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getTpContaCorrente';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const tipos: any[] = response.data.dataset.data;

    return tipos;
  }

  public static async getAgencia(
    cdBanco: string,
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getAgencia';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      CDBANCO: cdBanco,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    const agencias: any[] = response.data.dataset.data;

    return agencias;
  }

  public static async setAdmissaoSimplificada(
    row: any,
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;
    const cdOperador: string = store.getters.user.cdoperador;

    const route = 'setAdmissaoSimplificada';

    const params = {
      requestType: 'Row',
      row: {
        ...row,
        NRORG: nrOrg,
        CDOPERADOR: cdOperador,
      },
    };

    const response = await HttpRequest.post(route, params, showLoading);
    ExpectedError.throwResponseError(response);

    const success: boolean = response.data.dataset.data;

    return success;
  }

  public static async getTipoFormacaoParc(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getTipoFormacaoParc';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tiposFormacao: any[] = response.data.dataset.data;

      return tiposFormacao;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de formação!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getCursoAcademico(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getCursoAcademico';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const cursos: any[] = response.data.dataset.data;

      return cursos;
    } catch (err) {
      const message = 'Não foi possível carregar os cursos!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getInstituicaoEstrutura(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getInstituicaoEstrutura';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const instituicoes: any[] = response.data.dataset.data;

      return instituicoes;
    } catch (err) {
      const message = 'Não foi possível carregar as instituições estrutura!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getAreaFormacao(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getAreaFormacao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const areas: any[] = response.data.dataset.data;

      return areas;
    } catch (err) {
      const message = 'Não foi possível carregar as áreas de formação!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getBeneficio(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getBeneficio';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const beneficios: any[] = response.data.dataset.data;

      return beneficios;
    } catch (err) {
      const message = 'Não foi possível carregar os benefícios!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTipoVinculo(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getTipoVinculo';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tipos: any[] = response.data.dataset.data;

      return tipos;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de vínculo!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTipoAdmissao(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getTipoAdmissao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tipos: any[] = response.data.dataset.data;

      return tipos;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de admissão!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getVinculoEmpregaticio(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getVinculoEmpregaticio';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const vinculos: any[] = response.data.dataset.data;

      return vinculos;
    } catch (err) {
      const message = 'Não foi possível carregar os vínculos empregatícios!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTipoOcupacao(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getTipoOcupacao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tipos: any[] = response.data.dataset.data;

      return tipos;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de ocupação!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getOcupacao(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getOcupacao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const ocupacoes: any[] = response.data.dataset.data;

      return ocupacoes;
    } catch (err) {
      const message = 'Não foi possível carregar os cargos!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTipoSalario(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getTipoSalario';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const ocupacoes: any[] = response.data.dataset.data;

      return ocupacoes;
    } catch (err) {
      const message = 'Não foi possível carregar os tipos de salário!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async setAdmissaoCompleta(
    row: any,
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;
    const cdOperador: string = store.getters.user.cdoperador;

    const route = 'setAdmissaoCompleta';

    const params = {
      requestType: 'Row',
      row: {
        ...row,
        NRORG: nrOrg,
        CDOPERADOR: cdOperador,
      },
    };

    const response = await HttpRequest.post(route, params, showLoading);
    ExpectedError.throwResponseError(response);

    const data: any = response.data.dataset.data;

    return data;
  }

  public static async pesquisarCep(
    cep: string,
    showLoading = true,
  ) {
    const route = 'pesquisarCep';
    const nrOrg = store.getters.user.nrorg;

    const params = {
        requestType: 'FilterData',
        NRORG: nrOrg,
        CEP: cep,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      if (data.messages) {
          const message = data.messages[0].message;
          SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

          return undefined;
      }

      const cepInfo = data.dataset.data;

      return cepInfo;
    } catch (err) {
      const message = 'Não foi possível carregar as informações do CEP!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getMotivosAdmissao(): Promise<any[]> {
    const route = 'getMotivosAdmissao';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data;
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os motivos de admissão!';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTodosVinculos(): Promise<any[]> {
    const route = 'getTodosVinculosAdmissao';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data;
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os vínculos para "Vínculo Substituído"!';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async buscarPessoaCPF(cpf: string): Promise<any> {
    const route = 'buscarPessoaCPF';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRCPFPESSOA: cpf,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return !Util.isEmptyOrBlank(data.dataset.data) ? data.dataset.data : null;
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os vínculos para "Vínculo Substituído"!';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTiposTransferencia(): Promise<any[]> {
    const route = 'getTipoTransferencia';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Tipos de Transferência';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getLoteVinculos(): Promise<any[]> {
    const route = 'getLoteVinculos';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data;
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Lotes de Vinculo"!';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
}

export default AdmissaoController;
